module.exports = __webpack_public_path__ + "68662fbf9b73dfdadf218c158b82b12d.jpg";